<!-- Tarjeta de filtros -->
<div class="rounded-xl border border-slate-200 bg-white p-4 sm:p-5 mb-6">
  <div class="flex items-center justify-between mb-4">
    <h3 class="text-lg font-semibold text-slate-800 flex items-center gap-2">
      <i class="bi bi-funnel text-accent-500"></i>
      Filtros
    </h3>
    <button
      type="button"
      (click)="toggleFiltros()"
      class="md:hidden px-3 py-1 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 transition-colors"
    >
      <i [class]="mostrarFiltros() ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
    </button>
  </div>

  @if (mostrarFiltros()) {
  <ng-content />
  }
</div>
